import { BASE_CHAT_PATH } from './BASE_CHAT_PATH';
import { getPath } from './getPath';
export function getChatUrl(threadId) {
  return getPath(threadId ? `${BASE_CHAT_PATH}/${threadId}` : BASE_CHAT_PATH);
}